/**
 * Product ID constants for LINQ products
 * Used across the application for product identification and lookups
 */

export const PRODUCT_IDS = {
  LINQ_ONE: 'prod_QmwEcZEeTODmrW',
  LINQ_BLUE: 'prod_RQjmrtiHgXI5PS',
  LINQ_INFRA: 'prod_TI8X1aY7VApKAs',
  LINQ_INFRA_200_CONTACT: 'prod_V0ouQMnfLdZU3s',
  LINQ_SAPPHIRE: 'prod_Sus3q8anSlxfpM',
  LINQ_RESELLER: 'prod_UDIqyvLTlQVH54',
  LINQ_FIND_MY: 'prod_UVfcDzSYXwIvX0',
}

export const LINQ_BLUE_PRODUCT_IDS = [PRODUCT_IDS.LINQ_BLUE]

export const LINQ_INFRA_PRODUCT_IDS = [
  PRODUCT_IDS.LINQ_INFRA,
  PRODUCT_IDS.LINQ_INFRA_200_CONTACT,
]
